import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/** Ô chọn "Mẫu kiểm tra" ở đầu bảng chỉ tiêu */
export function QcTemplateSelect({
  templates,
  value,
  onChange,
  disabled,
}: {
  templates: any[];
  value?: string | null;
  onChange: (id: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <label htmlFor="qc-template-select" className="shrink-0 text-xs font-semibold text-slate-700">
        Mẫu kiểm tra
      </label>
      <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          id="qc-template-select"
          className="h-8 w-56 min-w-0 max-w-full bg-white text-xs font-semibold *:data-[slot=select-value]:block *:data-[slot=select-value]:min-w-0 *:data-[slot=select-value]:truncate"
        >
          <SelectValue placeholder="Chọn mẫu kiểm tra..." />
        </SelectTrigger>
        <SelectContent>
          {templates.map((tpl: any) => (
            <SelectItem key={tpl.id} value={tpl.id} className="text-xs">
              <span className="mr-1.5 font-mono font-bold text-indigo-700">[{tpl.code}]</span>
              {tpl.name}
              {tpl.version ? <span className="ml-1 text-slate-500">v{tpl.version}</span> : null}
              {tpl.status === "ARCHIVED" ? <span className="ml-1 text-amber-700">· Lưu trữ</span> : null}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
